import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import { getPaddingByIncomingIndent, TContainerProps } from './IndentContainer';
import { getRadiusByIncomingProps, TRounderProps } from './RounderContainer';

/**
 * Обертка добавляет компоненту, цвет бэкграунда, скругление и паддинги
 * indent: $united или $mobile & $desktop.
 * rounder: $radius или $desktop & $mobile.
 * bgColor: цвет подложки (default COLORS.BgSurface).
 */
const BlockContainer = styled.div<{
    indent: TContainerProps,
    rounder: TRounderProps,
    bgColor?: string,
}>`
    ${p => getPaddingByIncomingIndent(p.indent)};
    ${p => getRadiusByIncomingProps(p.rounder)};
    background-color: ${p => p.bgColor || COLORS.BgSurface};
    position: relative;
    width: 100%;
`;

export default BlockContainer;
